import _ from "lodash"

export function applyFilters(preferences, bet) {
  // console.log("preferences ", preferences)

  if (_.isEmpty(preferences) || preferences === undefined) return true

  // Check bookmaker filter
  const bookieIncluded =
    _.isEmpty(preferences.bookmakers) ||
    _.includes(preferences.bookmakers, bet.bookmaker2)

  // Check sport filter
  const sportIncluded =
    _.isEmpty(preferences.sports) ||
    _.includes(preferences.sports, bet.sport_name)

  const scoreboardIncluded =
    _.isEmpty(preferences.scoreboards) ||
    _.includes(preferences.scoreboards, bet.scoreboard)

  const marketIncluded =
    _.isEmpty(preferences.markets) ||
    _.includes(preferences.markets, bet.market)

  // Check odds range filter
  const oddsInRange =
    (preferences.minOdds === undefined || bet.odds >= preferences.minOdds) &&
    (preferences.maxOdds === undefined || bet.odds <= preferences.maxOdds)

  // Check EV range filter
  const evInRange =
    (preferences.minEv === undefined || bet.ev >= preferences.minEv) &&
    (preferences.maxEv === undefined || bet.ev <= preferences.maxEv)

  // Check updated since filter (in minutes)
  let updatedRecently = true
  if (preferences.updatedSince !== undefined && bet.last_modified) {
    const now = new Date()
    const lastModified = new Date(bet.last_modified)
    const diffInMs = now.getTime() - lastModified.getTime()
    const diffInMinutes = diffInMs / (1000 * 60)
    updatedRecently = diffInMinutes <= preferences.updatedSince
  }

  // console.log("Filters:", {
  //   bookmaker: bet.bookmaker2,
  //   bookieIncluded,
  //   sport: bet.sport_name,
  //   sportIncluded,
  //   odds: bet.odds,
  //   oddsInRange,
  //   ev: bet.ev,
  //   evInRange,
  //   lastModified: bet.last_modified,
  //   updatedRecently,
  // })

  return (
    bookieIncluded &&
    sportIncluded &&
    scoreboardIncluded &&
    marketIncluded &&
    oddsInRange &&
    evInRange &&
    updatedRecently
  )
}
